import { styled } from "goober";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";
import { ControlButton } from "./ControlButton";

const IconButton = styled(ControlButton)`
  width: 32px;
  padding: 0;
  justify-content: center;
`;

export function RefreshButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip content="Refresh">
      <IconButton type="button" onClick={onClick} aria-label="Refresh">
        <Icon name="refresh-ccw" size={16} color="var(--text-secondary)" />
      </IconButton>
    </Tooltip>
  );
}
